export default __webpack_public_path__ + "static/media/PH-C891.e9f1565a.webp";